import { get } from "../../utils/request";

export const getAllProductsByGender = async (gender) => {
  const data = await get("headers-products"); // data là array, không có data.data

  return data
    .filter((item) => item.gender === gender)
    .flatMap((item) => item.products || []);
};

export const getCategoriesByGender = async (gender) => {
  const data = await get("headers-products");
  const genderItem = data.find((item) => item.gender === gender);
  if (!genderItem) return [];

  return genderItem.cate || []; // trả về array các cate con
};
